var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQsr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6456 13.9545H13.7365L14.7876 15.3068L15.8217 16.5114L17.7706 18.9545H15.4751L14.1342 17.3068L13.4467 16.3295L11.6456 13.9545ZM17.9467 12.1818C17.9467 13.4508 17.7062 14.5303 17.2251 15.4205C16.7479 16.3106 16.0964 16.9905 15.2706 17.4602C14.4486 17.9261 13.5244 18.1591 12.4979 18.1591C11.4638 18.1591 10.5357 17.9242 9.71378 17.4545C8.89181 16.9848 8.24219 16.3049 7.76491 15.4148C7.28764 14.5246 7.04901 13.447 7.04901 12.1818C7.04901 10.9129 7.28764 9.83333 7.76491 8.94318C8.24219 8.05303 8.89181 7.375 9.71378 6.90909C10.5357 6.43939 11.4638 6.20455 12.4979 6.20455C13.5244 6.20455 14.4486 6.43939 15.2706 6.90909C16.0964 7.375 16.7479 8.05303 17.2251 8.94318C17.7062 9.83333 17.9467 10.9129 17.9467 12.1818ZM15.4524 12.1818C15.4524 11.3598 15.3293 10.6667 15.0831 10.1023C14.8407 9.53788 14.4979 9.10985 14.0547 8.81818C13.6115 8.52652 13.0926 8.38068 12.4979 8.38068C11.9032 8.38068 11.3842 8.52652 10.9411 8.81818C10.4979 9.10985 10.1532 9.53788 9.90696 10.1023C9.66454 10.6667 9.54332 11.3598 9.54332 12.1818C9.54332 13.0038 9.66454 13.697 9.90696 14.2614C10.1532 14.8258 10.4979 15.2538 10.9411 15.5455C11.3842 15.8371 11.9032 15.983 12.4979 15.983C13.0926 15.983 13.6115 15.8371 14.0547 15.5455C14.4979 15.2538 14.8407 14.8258 15.0831 14.2614C15.3293 13.697 15.4524 13.0038 15.4524 12.1818Z",
    fill: "url(#paint0_linear_450_1032)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_450_1032",
    x1: 2.65347,
    y1: -5.45779,
    x2: 21.6206,
    y2: -5.23638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446AEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQsr);
export default __webpack_public_path__ + "static/media/qsr.d65a566e296636845a824994aa3367d0.svg";
export { ForwardRef as ReactComponent };